import React, { useContext, useState } from 'react';

import {
  ReliabilityOption,
  ReliabilityHelp,
  ReliabilityHelpTrigger,
} from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';

const Step5 = () => {
  const {
    state: { step5 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);
  const [helpOpen, toggleHelpOpen] = useState(false);

  return (
    <div className="reliabilityCalculator__cell">
      {helpOpen ? (
        <ReliabilityHelp
          title="Incident Management/Disaster Recovery Plan"
          toggleHelpOpen={toggleHelpOpen}
        >
          <p>
            An incident management plan (also referred to as a "playbook" or
            "runbook") is typically service-specific and outlines the set of
            steps taken to detect and mitigate an incident.
          </p>
          <p>
            A disaster recovery plan (DRP) is a documented, specific set of
            steps taken in the event that normal operations are significantly
            disrupted.
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="hero-titleWrapper u-contrast">
          <h1 className="hero-title">
            Do you currently have an{' '}
            <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
              incident management or disaster recovery
            </ReliabilityHelpTrigger>{' '}
            plan in place?
          </h1>
        </div>
      )}
      <div className="reliabilityCalculator__grid-2">
        <ReliabilityOption
          title="Yes"
          active={step5 === 'yes'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step5: 'yes',
              },
            });
          }}
        />
        <ReliabilityOption
          title="No"
          active={step5 === 'no'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step5: 'no',
              },
            });
          }}
        />
      </div>
    </div>
  );
};

export default Step5;
